// @flow

import React from 'react';
import PropTypes from 'prop-types';

import { Grid, Container, Typography } from '@material-ui/core';

import './style.css';

type Props = {
    children: any,
};

function SignInContainer(props: Props) {
    const { children } = props;

    return (
        <Grid container className="sign-container">
            <Grid item sm={12} md={12} lg={12}>
                <Container maxWidth="sm" className="sign-box">
                    {children}
                    <Typography component="div" className="sign-ribbon">
                        {/* <Typography
                            component="div"
                            className="sign-ribbon-inner"
                        >
                            Coming Soon
                        </Typography> */}
                    </Typography>
                </Container>
            </Grid>
        </Grid>
    );
}

SignInContainer.propTypes = {
    children: PropTypes.any.isRequired,
};

export default SignInContainer;
